// Supabase Configuration
// Replace these values with your actual Supabase project credentials
// You can find these in your Supabase project dashboard under Settings > API

export const SUPABASE_CONFIG = {
  url: process.env.REACT_APP_SUPABASE_URL || 'your_supabase_project_url',
  anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || 'your_supabase_anon_key'
}

// Instructions:
// 1. Create a .env.local file in your project root
// 2. Add the following variables:
//    REACT_APP_SUPABASE_URL=your_actual_supabase_url
//    REACT_APP_SUPABASE_ANON_KEY=your_actual_anon_key
// 3. Get these values from your Supabase project dashboard
